import styled from 'react-emotion';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const EducatorContainer = styled('span')`
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.small};
  font-weight: ${theme.font.weight.regular};
  color: ${colors.designSystem.marker};
  line-height: ${theme.font.lineHeight.small};
  letter-spacing: 0.4px;
`;

export default EducatorContainer;
